import React from 'react';
import PropTypes from 'prop-types';
import AnchorLink from '@/src/components/AnchorLink';
import { buildContentfulImageURL } from '@utils/image';
import { QUIZ_URL } from '../../../../constants/routes';
import Image from '../../../Image';
import s from './MoreQuizzes.module.scss';

const propTypes = {
  relatedQuizzes: PropTypes.array,
};

const MoreQuizzes = ({ relatedQuizzes = null }) => {
  return (
    <>
      {relatedQuizzes && (
        <div className={s.root}>
          <h3>MORE QUIZZES</h3>
          <div className={s.quizListContainer}>
            {relatedQuizzes.map((item) => {
              const imageSet = [
                {
                  src: buildContentfulImageURL(item.image, {
                    width: 708,
                    height: 544,
                    fit: 'fill',
                    focus: 'top',
                    format: 'webp',
                  }),
                  media: '(max-width: 768px)',
                  type: 'image/webp',
                },
                {
                  src: buildContentfulImageURL(item.image, {
                    width: 708,
                    height: 544,
                    fit: 'fill',
                    focus: 'top',
                    format: 'jpg',
                  }),
                  media: '(max-width: 768px)',
                  type: 'image/jpeg',
                },
                {
                  src: buildContentfulImageURL(item.image, {
                    width: 388,
                    height: 248,
                    fit: 'fill',
                    focus: 'top',
                    format: 'webp',
                  }),
                  type: 'image/webp',
                },
                {
                  src: buildContentfulImageURL(item.image, {
                    width: 388,
                    height: 248,
                    fit: 'fill',
                    focus: 'top',
                    format: 'jpg',
                  }),
                  type: 'image/jpeg',
                },
              ];
              return (
                <AnchorLink
                  href={`${QUIZ_URL}/${item.externalId}`}
                  className={s.itemWrapper}
                  key={item.id}
                >
                  <div className={s.image}>
                    <Image imageSet={imageSet} cover />
                  </div>
                  <div className={s.innerBorder}>
                    <div className={s.content}>
                      <h4 className={s.title}>{item.title}</h4>
                      <div className={s.byLine}>{`by ${item.byLine}`}</div>
                    </div>
                  </div>
                </AnchorLink>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

MoreQuizzes.propTypes = propTypes;
export default MoreQuizzes;
